document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.section-header');
  // check if the page was reloaded and remove the animation performed flag
  if (performance.getEntriesByType('navigation').length > 0) {
    const navigationEntry = performance.getEntriesByType('navigation')[0];
    if (navigationEntry.type === 'reload') {
      sessionStorage.removeItem('animationPerformed');
    }
  }
  // check if the logo was clicked and remove the animation performed flag
  const logo = document.querySelector('#a-logo');
  logo.addEventListener('click', function (event) {
    sessionStorage.removeItem('animationPerformed');
  });

  if (!header || window.matchMedia('(min-width: 1200px)').matches || sessionStorage.getItem('animationPerformed'))
    return;

  const preloadLogo = header.querySelector('.preload-logo');
  const mainLogo = header.querySelector('.main-logo--mobile');
  const icons = header.querySelector('.header__icons');
  const gsap = window.gsap;
  if (!preloadLogo || !mainLogo || !icons || !gsap) return;

  let tl = null;
  let letterDurationCoefficient = 0.2;
  let borderDurationCoefficient = 0.6;
  let lettersEasing = 'none';
  let bordersEasing = 'none';
  let initialScrollPosition = window.scrollY;

  // check if the animation was performed
  const animationPerformed = () => sessionStorage.getItem('animationPerformed') === 'true';

  // set the animation timeline
  const setLogoAnimation = () => {
    if (tl) return tl; // Ensure single timeline instance

    const elements = {
      letterS: preloadLogo.querySelector('.s'),
      letterI: preloadLogo.querySelector('.i'),
      letterM1: preloadLogo.querySelector('.m1'),
      letterP: preloadLogo.querySelector('.p'),
      letterL: preloadLogo.querySelector('.l'),
      letterE: preloadLogo.querySelector('.e'),
      letterH: preloadLogo.querySelector('.h'),
      letterU: preloadLogo.querySelector('.u'),
      letterM2: preloadLogo.querySelector('.m2'),
      letterA: preloadLogo.querySelector('.a'),
      letterN: preloadLogo.querySelector('.n'),
      divider: preloadLogo.querySelector('.divider'),
      borderTop: preloadLogo.querySelector('.border-top'),
      borderBottom: preloadLogo.querySelector('.border-bottom'),
      borderLeft: preloadLogo.querySelector('.border-left'),
      borderRight: preloadLogo.querySelector('.border-right'),
    };

    tl = gsap.timeline({
      paused: true,
      repeat: 0,
      onComplete: placeHeaderElements,
    });

    gsap.set(elements.borderBottom, { scaleX: 0, transformOrigin: 'center' });
    gsap.set([elements.borderLeft, elements.borderRight], { scaleY: 0, transformOrigin: 'bottom' });
    gsap.set(elements.borderTop, { scaleX: 0, transformOrigin: 'left' });

    tl.add('lettersAnimation')
      // left
      // s
      .to(
        elements.letterS,
        { x: 87, duration: letterDurationCoefficient * 2.0, ease: lettersEasing },
        `lettersAnimation+=${letterDurationCoefficient * 0.1}`
      )
      // i
      .to(
        elements.letterI,
        { x: 79, duration: letterDurationCoefficient * 1.7, ease: lettersEasing },
        `lettersAnimation`
      )
      .to(elements.letterI, { opacity: 0, duration: 0 }, `lettersAnimation+=${letterDurationCoefficient * 1.7}`)
      // m1
      .to(
        elements.letterM1,
        { x: 55, duration: letterDurationCoefficient * 1.3, ease: lettersEasing },
        `lettersAnimation`
      )
      .to(elements.letterM1, { opacity: 0, duration: 0 }, `lettersAnimation+=${letterDurationCoefficient * 1.3}`)
      // p
      .to(
        elements.letterP,
        { x: 36, duration: letterDurationCoefficient * 0.9, ease: lettersEasing },
        `lettersAnimation`
      )
      .to(elements.letterP, { opacity: 0, duration: 0 }, `lettersAnimation+=${letterDurationCoefficient * 0.9}`)
      // l
      .to(
        elements.letterL,
        { x: 20, duration: letterDurationCoefficient * 0.5, ease: lettersEasing },
        `lettersAnimation`
      )
      .to(elements.letterL, { opacity: 0, duration: 0 }, `lettersAnimation+=${letterDurationCoefficient * 0.5}`)
      // e
      .to(
        elements.letterE,
        { x: 3, duration: letterDurationCoefficient * 0.1, ease: lettersEasing },
        'lettersAnimation'
      )
      .to(elements.letterE, { opacity: 0, duration: 0 }, `lettersAnimation+=${letterDurationCoefficient * 0.1}`)

      // right
      // h
      .to(
        elements.letterH,
        { x: -3, duration: letterDurationCoefficient * 0.1, ease: lettersEasing },
        'lettersAnimation'
      )
      .to(elements.letterH, { opacity: 0, duration: 0 }, `lettersAnimation+=${letterDurationCoefficient * 0.1}`)
      .to(elements.letterH, { x: 83, duration: 0 }, `lettersAnimation+=${letterDurationCoefficient * 0.1}`)
      .to(elements.letterH, { opacity: 1, duration: 0 }, `lettersAnimation+=${letterDurationCoefficient * 0.1}`)
      .to(
        elements.letterH,
        { x: -3, duration: letterDurationCoefficient * 2.0, ease: lettersEasing },
        `lettersAnimation+=${letterDurationCoefficient * 0.1}`
      )
      // u
      .to(
        elements.letterU,
        { x: -24, duration: letterDurationCoefficient * 0.6, ease: lettersEasing },
        `lettersAnimation`
      )
      .to(elements.letterU, { opacity: 0, duration: 0 }, `lettersAnimation+=${letterDurationCoefficient * 0.6}`)
      // m2
      .to(
        elements.letterM2,
        { x: -45, duration: letterDurationCoefficient * 1.1, ease: lettersEasing },
        `lettersAnimation`
      )
      .to(elements.letterM2, { opacity: 0, duration: 0 }, `lettersAnimation+=${letterDurationCoefficient * 1.1}`)
      // a
      .to(
        elements.letterA,
        { x: -66, duration: letterDurationCoefficient * 1.6, ease: lettersEasing },
        `lettersAnimation`
      )
      .to(elements.letterA, { opacity: 0, duration: 0 }, `lettersAnimation+=${letterDurationCoefficient * 1.6}`)
      // n
      // .to(elements.letterN, { x: -86, duration: letterDurationCoefficient * 2.0, ease: lettersEasing }, `lettersAnimation`)
      .to(elements.letterN, { opacity: 0, duration: 0 }, `lettersAnimation+=${letterDurationCoefficient * 0.1}`)

      .add('bordersAnimation') // add all the borders related animation
      .set(
        [elements.borderBottom, elements.borderRight, elements.borderLeft, elements.borderTop],
        { opacity: 1 },
        'bordersAnimation-=0.1'
      )
      // bottom
      .to(
        elements.borderBottom,
        { scaleX: 1, duration: borderDurationCoefficient * 0.4, ease: bordersEasing },
        'bordersAnimation'
      )
      // right
      .to(
        elements.borderRight,
        { scaleY: 1, duration: borderDurationCoefficient * 0.6, ease: bordersEasing },
        `bordersAnimation+=${borderDurationCoefficient * 0.4}`
      )
      // left
      .to(
        elements.borderLeft,
        { scaleY: 1, duration: borderDurationCoefficient * 0.2, ease: bordersEasing },
        `bordersAnimation+=${borderDurationCoefficient * 0.4}`
      )
      // top
      .to(
        elements.borderTop,
        { scaleX: 1, duration: borderDurationCoefficient * 0.4, ease: bordersEasing },
        `bordersAnimation+=${borderDurationCoefficient * 0.6}`
      );

    return tl;
  };

  // appear hidden header elements after animation completion
  const placeHeaderElements = () => {
    gsap.to(icons, { opacity: 1, duration: 0.4, delay: 0.2 });
    gsap.to(
      preloadLogo,
      {
        left: window.matchMedia('(max-width: 750px)').matches ? 66 : 78,
        duration: 0.6,
        ease: 'power2.out',
      },
      '<'
    );
    gsap.to(mainLogo, { opacity: 1, duration: 0.3 }, '>');
    gsap.to(preloadLogo, { opacity: 0, duration: 0.3, display: 'none' }, '>0.3');
  };

  // play the timeline
  const triggerAnimation = () => {
    if (animationPerformed()) return;
    sessionStorage.setItem('animationPerformed', 'true');
    tl = setLogoAnimation();
    tl.play();
  };

  // play the timeline after 1.5 sec if no events triggered
  const startAnimationWithFallback = () => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => {
        setTimeout(() => triggerAnimation(), 1500);
      });
    } else {
      // Fallback for browsers without requestIdleCallback
      setTimeout(() => triggerAnimation(), 1500);
    }
  };

  window.addEventListener('load', function () {
    startAnimationWithFallback();
  });

  // play on scroll
  let debounceScroll;
  window.addEventListener('scroll', () => {
    if (debounceScroll) clearTimeout(debounceScroll);
    debounceScroll = setTimeout(() => {
      if (!animationPerformed() && Math.abs(window.scrollY - initialScrollPosition) > 200) {
        triggerAnimation();
      }
    }, 100);
  });

  // play on header click
  //  header.addEventListener('click', triggerAnimation);
});
